import React, {FC, ReactNode} from "react"
import Drawer from "react-modern-drawer"
import "react-modern-drawer/dist/index.css"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import styled, {css} from "styled-components"

interface Props {
  icon: IconTypes
  size?: number
  children?: ReactNode
}

export const BottomSheet: FC<Props> = ({icon, size = 24, children}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <>
      <IconWrapper onClick={toggleDrawer}>
        <Icon icon={icon} size={size} />
      </IconWrapper>
      <DrawerWrapper>
        <StyledDrawer open={isOpen} onClose={toggleDrawer} direction="bottom" enableOverlay overlayColor="rgba(0, 0, 0, 0.5)">
          <DrawerContent>{children}</DrawerContent>
        </StyledDrawer>
      </DrawerWrapper>
    </>
  )
}

const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`

const DrawerWrapper = styled.div`
  .EZDrawer {
    height: auto !important;
    max-height: 90vh !important;
  }

  .EZDrawer__overlay {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
`

const StyledDrawer = styled(Drawer)`
  ${({theme}) => css`
    /* styles get overrode if no !important flag */
    height: auto !important;
    max-height: 80vh !important;
    border-top-left-radius: ${theme.border.radius.large} !important;
    border-top-right-radius: ${theme.border.radius.large} !important;
    overflow: scroll !important;
  `}
`

const DrawerContent = styled.div`
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
`
